import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export class AdapterDialogDayjs extends AdapterDayjs {
  constructor(...args) {
    super(...args);
    const parse = this.parse;
    this.parse = (value, format) => {
      // Dayjs uses JS Date parsing, which otherwise turns year 0026 into 1926
      // (or rejects it). Keep the literal year while editing; expand on blur.
      const tokens = format?.match(/YYYY|MM|DD/g);
      const parts = value?.match(/\d+/g);
      const yearIndex = tokens?.indexOf("YYYY");
      if (yearIndex >= 0 && parts?.length === tokens.length && /^00\d{2}$/.test(parts[yearIndex])) {
        let index = 0;
        const corrected = value.replace(/\d+/g, part => index++ === yearIndex ? `20${part.slice(2)}` : part);
        const parsed = parse(corrected, format);
        return parsed?.isValid() ? parsed.year(Number(parts[yearIndex])) : parsed;
      }
      return parse(value, format);
    };
  }
}
